module.exports = __webpack_public_path__ + "media/pdfs/wheel_tire_terms-15aee4ec86c8405fa0ace045488d5f58.pdf";